import { BatchHttpLink } from '@apollo/client/link/batch-http/index.js';
import { IRK_API_URL } from '$lib/constants';
import { customFetch as fetch } from '$lib/utils/fetch';
import { browser } from '$app/environment';

export const httpLink = () =>
  new BatchHttpLink({
    uri: `${IRK_API_URL}/graphql`,
    fetch,
    includeExtensions: true,
    batchMax: browser ? 3 : 0
  });
